import { useState } from "react";
import { Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/styles/customTable.scss";
import useColumnResize from "../../../hooks/useColumnResize";

const CleanedAddressTable = ({ data, onSortChange }) => {
  const [sortConfig, setSortConfig] = useState({ key: "CreationDateTime", direction: "desc" });
  const { getResizeProps } = useColumnResize();

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString("pl-PL");
  };

  const items = Array.isArray(data) ? data : [];

  return (
    <div>
      <Table
        responsive
        striped
        bordered
        hover
        size="sm"
        className="custom-table"
      >
        <thead>
          <tr>
            <th onClick={() => requestSort("TerminalEx")} {...getResizeProps()}>Terminal EX {getSortArrow("TerminalEx")}</th>
            <th onClick={() => requestSort("TerminalDr")} {...getResizeProps()}>Terminal DR {getSortArrow("TerminalDr")}</th>
            <th onClick={() => requestSort("CreationDateTime")} {...getResizeProps()}>Data {getSortArrow("CreationDateTime")}</th>
            <th onClick={() => requestSort("InputPostalCode")} {...getResizeProps()}>Kod pocztowy {getSortArrow("InputPostalCode")}</th>
            <th onClick={() => requestSort("InputCityName")} {...getResizeProps()}>Miasto {getSortArrow("InputCityName")}</th>
            <th onClick={() => requestSort("InputStreetNameAndStreetNumberAndApartmentNumber")} {...getResizeProps()}>Adres {getSortArrow("InputStreetNameAndStreetNumberAndApartmentNumber")}</th>
            <th onClick={() => requestSort("OutputAddressMatchingStatus")} {...getResizeProps()}>Status adresu {getSortArrow("OutputAddressMatchingStatus")}</th>
            <th onClick={() => requestSort("OutputAddressGeocodingStatus")} {...getResizeProps()}>Status geokodowania {getSortArrow("OutputAddressGeocodingStatus")}</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr key={`${item.terminalEx}-${item.terminalDr}-${index}`}>
                <td>{item.terminalEx}</td>
                <td>{item.terminalDr}</td>
                <td>{formatDate(item.creationDateTime)}</td>
                <td>{item.inputPostalCode}</td>
                <td>{item.inputCityName}</td>
                <td>{item.inputStreetNameAndStreetNumberAndApartmentNumber}</td>
                <td>{item.outputAddressMatchingStatus}</td>
                <td>{item.outputAddressGeocodingStatus}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default CleanedAddressTable;
